export default __webpack_public_path__ + "static/media/yellow.14b4ce48.png";